
import { getWordpressPostBySlug } from "@src/functions/wordpress";
import WordpressPost from "../common/components/WordpressPost";

export async function getServerSideProps() {
  const postJson = await getWordpressPostBySlug("in-the-news");

  return {
    props: { data: Array.isArray(postJson) ? postJson[0] : postJson },
  }
}

function Post ({ data }: any) {
  return (
    <WordpressPost data={data} />
  );
};

export default Post;